// extracted by mini-css-extract-plugin
export default {"pendingeKycBox":"pendingKyc_pendingeKycBox__2SEKD","pendingKycBox1":"pendingKyc_pendingKycBox1__oan0I","pendingKycBox2":"pendingKyc_pendingKycBox2__ZrKV3"};